import {FC, useState, createContext, useContext, ReactNode} from 'react'
import {WithChildren} from '../../../../_metronic/helpers'
import {RegisterationContextProps, initialRegistration} from './_models'

const RegisterationContext = createContext<RegisterationContextProps>(initialRegistration)

const RegisterationProvider: FC<WithChildren> = ({children}) => {
  const [helpPlace, setHelpPlace] = useState<ReactNode>('')

  return (
    <RegisterationContext.Provider
      value={{
        helpPlace,
        setHelpPlace,
      }}
    >
      {children}
    </RegisterationContext.Provider>
  )
}

const useRegistrationView = () => useContext(RegisterationContext)

export {RegisterationProvider, useRegistrationView}
